import { useState } from "react";
import PropTypes from "prop-types";
import { useSelector, useDispatch } from "react-redux";
import classNames from "classnames";

import { setRangeSelectParams } from "@/src/store/filter";
import { numberFormatter } from "@/src/helpers/number-formatter";
import { onlyNumber } from "helpers/only-number";

import Input from "@/src/components/common/input";

import styles from "@/src/components/listing-search/filter-items/styles.module.css";

const PriceInput = ({ filter }) => {
  const reduxRangeItems = useSelector((state) => state.filter.rangeselectitems);
  const filterKey = filter?.key;
  const priceParams = reduxRangeItems?.find((item) => item.key === filterKey) || {};
  const [defaultCurrencyValue, setDefaultCurrencyValue] = useState("try");

  const dispatch = useDispatch();

  const handlePriceChange = (type, event, key) => {
    const newValue = event.target.value?.replaceAll(".", "");
    if (!onlyNumber(newValue) && newValue !== "") return;
    const filterObject = {
      key: filterKey,
      value: {
        min: type === "min" ? newValue : priceParams?.value?.min,
        max: type === "max" ? newValue : priceParams?.value?.max,
        currency: priceParams?.value?.currency,
      },
    };
    const newCriteriaParams = reduxRangeItems?.filter((item) => item.key !== filterKey);
    newCriteriaParams.push(filterObject);
    dispatch(setRangeSelectParams(newCriteriaParams));
  };

  const handlePriceCurrencyChange = (currencyId) => {
    setDefaultCurrencyValue("");
    const filterObject = {
      key: filterKey,
      value: {
        min: priceParams?.value?.min,
        max: priceParams?.value?.max,
        currency: currencyId,
      },
    };
    const newCriteriaParams = reduxRangeItems?.filter((item) => item.key !== filterKey);
    newCriteriaParams.push(filterObject);
    dispatch(setRangeSelectParams(newCriteriaParams));
  };

  const minValue = numberFormatter(reduxRangeItems.find((item) => item.key === filterKey)?.value?.min) || "";
  const maxValue = numberFormatter(reduxRangeItems.find((item) => item.key === filterKey)?.value?.max) || "";

  return (
    <div className={styles.priceInputContainer}>
      <div className={styles.currencyTabs}>
        {filter?.config?.currency?.values?.map((currency) => (
          <button
            key={currency.id}
            className={classNames(styles.currencyTab, {
              [styles.currencyTabActive]:
                currency.id === priceParams?.value?.currency ||
                (!priceParams?.value?.currency && currency.id === defaultCurrencyValue),
            })}
            onClick={() => handlePriceCurrencyChange(currency.id)}
          >
            {currency.name}
          </button>
        ))}
      </div>

      <div className={styles.priceInputWrapper}>
        <div className={styles.minMaxInputWrapper}>
          <Input
            placeholder="Min"
            value={minValue}
            onChange={(e) => handlePriceChange("min", e, filter?.key)}
            inputClass={styles.minMaxInput}
          />
        </div>

        <span className={styles.textAlto}>-</span>

        <div className={styles.minMaxInputWrapper}>
          <Input
            placeholder="Max"
            value={maxValue}
            onChange={(e) => handlePriceChange("max", e, filter?.key)}
            inputClass={styles.minMaxInput}
          />
        </div>
      </div>
    </div>
  );
};

PriceInput.propTypes = {
  filter: PropTypes.object,
  filterKey: PropTypes.string,
};

export default PriceInput;
